import Icon from "@core-components/icon/Icon";
import InfoCardGrid from "@core-components/info-card/InfoCardGrid";

import useAppTranslation from "@hooks/language/useAppTranslation";

const ValorantInfoCards = () => {
  const { t } = useAppTranslation("pages.valorant.infoCards");
  const cards = [
    {
      icon: <Icon.FastDelivery size={50} />,
      title: t("instantDelivery.title"),
      text: t("instantDelivery.text"),
    },
    {
      icon: <Icon.Trophy size={50} />,
      title: t("rankedReady.title"),
      text: t("rankedReady.text"),
    },
    {
      icon: <Icon.Chat size={50} />,
      title: t("premiumSupport.title"),
      text: t("premiumSupport.text"),
    },
  ];

  return <InfoCardGrid cards={cards} />;
};

export default ValorantInfoCards;
